import { AxiosResponse } from 'axios';

import RestAPI from 'components/Common/restApi';
import { useQuestionDraftStateActions } from 'components/CustomerIntakeSettings/requestGuide/useQuestionDraftState';

export type ServiceTypesResponse = {
  service_types: string[];
};

export type SettingsPayload = Array<{
  industry: string;
  service_types: string[];
}>;

const deleteType = async (name: string) => {
  await RestAPI.deleteWithFormData('/alpha/customer_intake_flow/settings/service_types', {
    service_type: name,
  });
  useQuestionDraftStateActions.deleteServiceType(name);
};

const add = async (serviceType: string) =>
  RestAPI.postWithFormData('/alpha/customer_intake_flow/settings/service_types/add', {
    service_type: serviceType,
  });

const onboarding = async (): Promise<boolean> => {
  const { data } = (await RestAPI.get(
    '/alpha/customer_intake_flow/settings/service_types/onboarding_status'
  )) as AxiosResponse<{
    onboarding_complete: boolean;
  }>;

  return data.onboarding_complete;
};

const get = async () =>
  (await RestAPI.get('/alpha/customer_intake_flow/settings/service_types')) as AxiosResponse<ServiceTypesResponse>;

const saveOnboardingConfig = async (settings: SettingsPayload) => {
  await RestAPI.postWithFormData('/alpha/customer_intake_flow/settings/service_types', {
    settings,
  });
};

export const serviceTypesApi = {
  deleteType,
  add,
  onboarding,
  get,
  saveOnboardingConfig,
};
